import $ from 'jquery';
import slick from 'slick-carousel';

class Quotes {
	constructor() {
		this.$quotes = $('.quotes__slides');
		this.url = '/data/quotes.json';
		this.content = [];
	}

	init() {
		this.getData();
	}

	fetchDataByUrl = async (url) => {
		try {
			const response = await window.fetch(url);
			if (response.ok) {
				const json = await response.json();
				return json;
			}
		}catch (e) {
			console.error('Error in fetch', e);
		}
	}

	getData() {
		this.fetchDataByUrl(this.url)
			.then(resp => {
				this.content = resp;
				this.addContentToMarkup();
			});
	}

	addContentToMarkup() {
		this.content.forEach(({ fact }) => {
			const $slide = $('<div></div>').attr({ class: 'quotes__slide' });
			const $text = $('<p></p>').attr({ class: 'quotes__text' }).text(fact);
			if (fact.length > 150) {
				$text.addClass('quotes__text_small');
			}
			$text.appendTo($slide);
			$slide.appendTo(this.$quotes);
		});
		this.initializeSlider();
	}

	initializeSlider() {
		this.$quotes.slick({
			infinite: true,
			arrows: false,
			dots: false,
			pauseOnHover: false,
			autoplay: true,
			autoplaySpeed: 3000
		});
	}
}

export default Quotes;



// WEBPACK FOOTER //
// ./app/scripts/quotes.js